import { useMemo, useRef } from "react";
import { deprecatedWarn } from "../utils";
const useLoaded = (loading) => {
  deprecatedWarn("useLoaded");
  const toggleCount = useRef(0);
  const loaded = useMemo(() => {
    if (loading === true || loading === false && toggleCount.current > 0) {
      toggleCount.current = toggleCount.current + 1;
    }
    if (toggleCount.current > 1) {
      return true;
    }
    return false;
  }, [loading]);
  return loaded;
};
var useLoaded_default = useLoaded;
export {
  useLoaded_default as default
};
